import request from "./request";

export function getUsersAPI(params: Record<string, string>) {
    return request(`/api/Users?${new URLSearchParams(params)}`, { method: 'GET' });
}

export function getAssignitionUsersAPI(params: Record<string, string>) {
    return request(`/api/AdUsers/search?${new URLSearchParams(params)}`, { method: 'GET' });
} 